import { AccessIssueSolutionLabel, Tenancy } from '@acp/shared';
import { useMemo } from 'react';

export function useTenancyForm(
    currentTenancy: Tenancy | null,
    formType?: AccessIssueSolutionLabel
) {
    const formTypeHelpText = useMemo(() => {
        if (formType === undefined) {
            return null;
        }

        if (formType === AccessIssueSolutionLabel.AddTenantDetails) {
            return 'Please enter the current tenancy details for this property. ';
        }

        if (formType === AccessIssueSolutionLabel.UpdateTenantDetails) {
            return 'Please review the tenancy details below and make any changes as necessary. ';
        }

        if (formType === AccessIssueSolutionLabel.ConfirmTenantDetails) {
            return 'Please confirm the tenancy details below and make any changes as necessary. ';
        }

        if (formType === AccessIssueSolutionLabel.ConfirmVacantTenantDetails) {
            return 'Please confirm if the tenancy below is vacant and make any changes as necessary. ';
        }

        if (formType === AccessIssueSolutionLabel.AddEmail) {
            return 'We send email-based Entry Notifications, however none of the occupants have an email address. Please add an email address to at least one occupant';
        }

        return null;
    }, [formType]);

    const confirmButtonLabel = useMemo(() => {
        if (currentTenancy === null || currentTenancy.occupants.length === 0) {
            return 'Confirm vacant tenancy';
        }

        return 'Confirm tenancy';
    }, [currentTenancy]);

    return {
        formTypeHelpText,
        confirmButtonLabel,
    };
}
